
export type NoteType = 'note' | 'quote' | 'emotion' | 'behaviour' | 'pain' | 'insight' | 'opportunity';

export type NoteMode = 'capturing' | 'analysing';

export const capturingNoteTypes: NoteType[] = ['note', 'quote', 'emotion', 'behaviour'];
export const analysingNoteTypes: NoteType[] = ['pain', 'insight', 'opportunity'];

export interface NoteData {
  type: NoteType;
  content: string;
  isEditing: boolean;
  highlighted?: boolean;
  mode?: NoteMode;
}

export interface AnalysisResults {
  themes: string[];
  emotions: string[];
  painPoints: string[];
  insights: string[];
  opportunities: string[];
  recommendations: string[];
}

export interface User {
  id: string;
  email: string;
  name: string;
}
